import { PageContainer, ProCard, StatisticCard } from '@ant-design/pro-components';
import { Col, Row } from 'antd';
import {
  AuditOutlined,
  TeamOutlined,
  FileSearchOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';

/**
 * Dashboard 暂用占位统计数据. 后端就绪后接 /api/admin/v1/statistics/.
 */
const STATS = [
  {
    title: '考试场次数',
    value: 0,
    icon: <AuditOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    suffix: '场',
  },
  {
    title: '总用户数',
    value: 0,
    icon: <TeamOutlined style={{ fontSize: 32, color: '#52c41a' }} />,
    suffix: '人',
  },
  {
    title: '待评卷数',
    value: 0,
    icon: <FileSearchOutlined style={{ fontSize: 32, color: '#faad14' }} />,
    suffix: '份',
  },
  {
    title: '今日订单',
    value: 0,
    icon: <ShoppingCartOutlined style={{ fontSize: 32, color: '#eb2f96' }} />,
    suffix: '单',
  },
];

export default function DashboardPage() {
  return (
    <PageContainer header={{ title: '仪表盘', subTitle: '系统总览' }}>
      <Row gutter={[16, 16]}>
        {STATS.map((s) => (
          <Col xs={24} sm={12} md={6} key={s.title}>
            <StatisticCard
              statistic={{
                title: s.title,
                value: s.value,
                suffix: s.suffix,
                icon: s.icon,
              }}
            />
          </Col>
        ))}
      </Row>

      <ProCard title="待办事项" style={{ marginTop: 16 }} bordered>
        <p style={{ color: '#999' }}>暂无数据。后端 statistics endpoint 就绪后接入。</p>
      </ProCard>
    </PageContainer>
  );
}
